import React, {useEffect, useState} from "react";
import {api} from "../../api/api";

export const phrPrepare = (data) => {
    const phr = {}
    for (let i = 0; i < data.length; i++) {
        phr[data[i].JsId] = {
            ru: data[i].ru,
            en: data[i].en,
            fr: data[i].fr,
            ar: data[i].ar,
            zh: data[i].zh,
            es: data[i].es,
            de: data[i].de
        }
    }
    return phr
}

export const useTranslationDefs = (def="ru") => {
    const [language, setLanguage] = useState(def)
    const [translations, setTranslations] = useState({})
    const [isLoaded, setIsLoaded] = useState(false)

    const fetchData = async () => {
        if (sessionStorage.getItem("lng_json") === null) {
            await api.getI18n().then(res => {
                if (res.status === 200) {
                    const data = res.data
                    // let phr = phrPrepare(data)
                    sessionStorage.setItem("lng_json", JSON.stringify(phrPrepare(data)))
                }
            })
        }
        return await JSON.parse(sessionStorage.getItem("lng_json"))
    }

    useEffect( () => {
        fetchData().then(res => {
            setTranslations(res)
            setIsLoaded(true)
        })

    }, [])

    return  {
        language: language,
        getTranslation: (id) => {
            // debugger
            if (!translations[id] || translations[id][language]=== undefined) {
                return ""
            }
            return (translations[id][language]!=="") ? translations[id][language] : translations[id].en
        },
        setLanguage: setLanguage,
        i18nIsLoad: isLoaded
    }

}

const TranslationContext = React.createContext({});
export const TranslationProvider = TranslationContext.Provider

export default TranslationContext